import { FC, memo, useCallback, useContext, useEffect, useState } from "react";
import Particles from 'react-tsparticles'
import type { Container, Engine } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim"
import { loadImageShape } from "tsparticles-shape-image";
import { loadEmittersPlugin } from "tsparticles-plugin-emitters";
import { tsParticles } from "tsparticles-engine";
import { loadHeartShape } from "tsparticles-shape-heart";
import heartImage from "../../images/icons8-heart-30.png"
import { loadLifeUpdater } from "tsparticles-updater-life";
import { loadBubblesPreset } from "tsparticles-preset-bubbles";
import { loadParticlesRepulseInteraction } from "tsparticles-interaction-particles-repulse";
import { RenderContext } from "../CreateContext";

type HeartBubbleProps ={
    id:string
    LikeCount:number
}

export const HeartBubbleParticles:FC<HeartBubbleProps> =memo((props)=>{
    const { id, LikeCount } = props
    const {settings} = useContext(RenderContext);

    const particleLifeDelay = settings.find(setting => setting.KEY_NAME === "particle_life_delay");
    const lifeTimeDelay = typeof particleLifeDelay?.VALUE === "number" ? particleLifeDelay.VALUE : 6

    const particleQuantityRatio = settings.find(setting => setting.KEY_NAME === "particle_quantity_ratio");
    const quantityRatio = typeof particleQuantityRatio?.VALUE === "number" ? particleQuantityRatio.VALUE : 50

    let delay = 1 / (Math.floor(LikeCount / 10 ))/(quantityRatio * 0.02 + 0.1)

    if (delay < 0.1) {
      delay = 0.1;
  }

    const particlesInit = useCallback(async (engine: Engine) => {
      await loadSlim(engine);// 基本のload
      // await loadImageShape(engine) // 任意の画像を使いたいなら
      await loadEmittersPlugin(tsParticles);// emitterのload
      await loadHeartShape(tsParticles);// heartのload
      await loadLifeUpdater(tsParticles);// 時間制御のload
      await loadBubblesPreset(engine);// Bublleのload
    }, []);

    return(
           <Particles
            id={id}
            init={particlesInit}
            style={{
              borderRadius:"20px",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "50%",
              zIndex: 0, 
            }}
            options={{
                preset:"bubbles",
                fullScreen:false,
                // fpsLimit: 60,
                // retina_detect: true,
                background: {
                    color: "transparent",
                    // position: "50% 50%",
                },
                particles: {
                    shape: {
                      type: "heart", 
                    },
                    move:{
                        angle:40,
                        speed:4
                    },
                    size: {
                      value: { min: 4, max: 10 }
                    },
                    distance:{
                        value:100
                    }
                  },
                emitters: [
                  {
                    position:{
                      x: 92,
                      y: 94  
                    },
                    life:{
                      duration:2, // 一回の生成する時間
                      delay: lifeTimeDelay, // 一回の生成のインターバル(秒)
                    },
                    rate: {
                      delay:delay,  // quantity個のパーティクルの生成時間
                      quantity: quantityRatio===0 ? 0 : 1, // 生成するパーティクルの数(quantityRatioが0の時は表示しない)
                    },
                  },
                ]
            }}
  />
)
})

